import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './CountryStatistics.css';
import { useCountryStatistics } from '../../hooks/useCountryStatistics';
import PayoutSellerStatistics from '../PayoutStatistics/Sellers/PayoutSellerStatistics';
import { Empty } from "antd";
import { ProductType } from "motty-utils";
import ProductCard from "../ProductCard/ProductCard";
const CountryStatistics = (props) => {
    const statistics = useCountryStatistics(props.country);
    const renderEmptyStatistics = () => (_jsx(Empty, { description: "No payouts yet!" }));
    const renderStatistics = (countryStatistics) => (countryStatistics.topSellers.length ?
        _jsx(PayoutSellerStatistics, { statistics: countryStatistics.topSellers }) :
        renderEmptyStatistics());
    const renderProductCard = (product) => (_jsx(ProductCard, { product: product, children: renderStatistics(statistics[product]) }));
    return (_jsxs("div", { className: "country-statistics", children: [renderProductCard(ProductType.CreditCard), renderProductCard(ProductType.ConsumerLoan), renderProductCard(ProductType.Mortgage)] }));
};
export default CountryStatistics;
